<template>
  <div class="menu-tree">
    <el-tree
        ref="menuTree"
        node-key="menuId"
        show-checkbox
        :check-on-click-node="true"
        :default-checked-keys="checked"
        :data="menus"
        :indent="16"
        :props="{
          label: 'menuName'
        }"
        class="container">
    </el-tree>
  </div>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
export default {
  components: {},
  extends: BaseVue,
  props: {
    roleId: {
      type: String,
      default: null
    }
  },
  data() {
    return{
      menus: [],
      checked: []
    }
  },
  created() {
    this.loadTree();
    this.loadRights();
  },
  methods: {
    //加载所有有效的菜单树
    loadTree() {
      this.loading = true;
      this.postForm("/menu/allMenus", {
        onlyValid: true
      }, true).then(dr => {
        this.menus = dr.rows;
      }).finally(() => {
        this.loading = false;
      });
    },
    //加载本角色已授权的菜单
    loadRights() {
      this.loading = true;
      this.postForm("/role-menu/list", {
        roleId: this.roleId
      }, true).then(dr => {
        this.checked = [];
        dr.rows.forEach(r => this.checked.push(r.menuId));
      }).finally(() => {
        this.loading = false;
      });
    },

    getTree() {
      return this.$refs["menuTree"];
    },

    save() {
      let tree = this.getTree();
      let checked = tree.getCheckedKeys();
      this.loading = true;
      this.postForm("/role-menu/save", {
        roleId: this.roleId,
        menuIds: checked
      }, true).finally(() => {
        this.loading = false;
      })
    }
  },
  watch: {
    roleId(newValue,oldValue) {
      this.menus = [];
      this.checked = [];
      this.loadTree();
      this.loadRights();
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/css/variables";
.menu-tree{
  .header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid $color-border-primary;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    letter-spacing: 0.84px;
    line-height: 22px;
    font-weight: 600;
  }
  .container{
    ::v-deep .el-tree-node__content{
      height: 40px;
    }
    .menu-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-grow: 1;
      &-title {
        line-height: 36px;
        flex-grow: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      &-tool {
        .el-button {
        }

        .el-button + .el-button {
          margin-left: 5px;
        }
      }

      .menu-item.hover-bottom {
        border-bottom: 1px solid $color-primary;
      }

      .menu-item:hover {
        background-color: rgba(0, 0, 0, 0.05);
      }

      .job-type-sub-list {
        .menu-item {
          padding-left: 20px;
        }
      }
    }
  }
}

</style>